import React from 'react'
import './W3sect.css'
import image1 from '../Components/Images/banner3.jpg'
import image2 from '../Components/Images/banner5.jpg'
import { Container, Row, Col, Button } from "react-bootstrap";
function W3sect() {
  return (
    <div>
      <section class="w3l-grids-3 py-5">
        <div class="container py-md-5 py-3">
            <div class="row align-items-center">
                <div class="col-lg-6 header-sec">
                    <h6 class="title-subhny mb-2">Retail & Industrial Solutions</h6>
                    <h3 class="title-w3l">
                        Let’s Power Your Business with Smart Technology.
                    </h3>
                </div>
                <div class="col-lg-6 header-sec-paraw3 ps-lg-4">
                    <p class="" style={{fontFamily:"Poppins"}}>Upgrade your operations with reliable and cutting-edge equipment. From anti-theft EAS systems to high-precision weighing machines and industrial-grade printers, we provide complete solutions that drive efficiency and security for your business.</p>
                </div>
            </div>
            <div class="row bottom_grids text-left mt-lg-5 align-items-center">
                <div class="col-lg-4 col-md-6 mt-5">
                    <div class="grid-block">
                        <a href="#grids" class="d-block" style={{textDecoration:"none" , fontFamily:"Poppins", color:"Black"}}>
                            <div class="grid-block-infw3">
                                <div class="grid-block-icon"><span style={{
                                        background: "linear-gradient(135deg, #0A6E54 0%, #1B4B89 100%)",
                                        WebkitBackgroundClip: "text",
                                        backgroundClip: "text",
                                        color: "transparent",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        textDecoration: "none",
                                        marginTop: "auto",

                                }} class="fas fa-user-shield"></span></div>
                                <h4 class="my-3">Great Service & Support</h4>
                            </div>
                            <p class="">We ensure prompt installation, training, and after-sales support to keep your business running smoothly—every time. </p>
                        </a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 mt-5">
                    <div class="grid-block active">
                        <a href="#grids" class="d-block" style={{textDecoration:"none" , fontFamily:"Poppins", color:"Black"}}>
                            <div class="grid-block-infw3">
                                <div class="grid-block-icon"><span class="far fa-edit" style={{
                                     background: "linear-gradient(135deg, #0A6E54 0%, #1B4B89 100%)",
                                     WebkitBackgroundClip: "text",
                                     backgroundClip: "text",
                                     color: "transparent",
                                     display: "inline-flex",
                                     alignItems: "center",
                                     textDecoration: "none",
                                     marginTop: "auto",
                                }}></span></div>
                                <h4 class="my-3">Tailored Solutions</h4>
                            </div>
                            <p class="">Our products are configured to meet the specific needs of supermarkets, industries, and retail stores—ensuring maximum utility and performance. </p>
                        </a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 mt-5">
                    <div class="grid-block">
                        <a href="#grids" class="d-block" style={{textDecoration:"none", fontFamily:"Poppins", color:"Black"}}>
                            <div class="grid-block-infw3">
                                <div class="grid-block-icon"><span style={{
                                     background: "linear-gradient(135deg, #0A6E54 0%, #1B4B89 100%)",
                                     WebkitBackgroundClip: "text",
                                     backgroundClip: "text",
                                     color: "transparent",
                                     display: "inline-flex",
                                     alignItems: "center",
                                     textDecoration: "none",
                                     marginTop: "auto",
                                }} class="fas fa-signal" aria-hidden="true"></span></div>

                                <h4 class="my-3">
                                Reliable Performance</h4>
                            </div>
                            <p class="">Whether it’s point-of-sale systems or continuous inkjet printers, our solutions are trusted for their consistency, durability, and ease of use. </p>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>

   {/* video section */}
   

    
    
    </div>
  )
}

export default W3sect
